import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import '@shared/utils/string';
import '@shared/utils/array';

if (browserSupported()) {
  if (environment.production) {
    enableProdMode();
  }

  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
} else {
  window.location.replace('/browser-not-supported.html');
}

function browserSupported(): boolean {
  // check if browser is Opera (before Chrome/Edge check as Opera includes chrome related user agent data)
  if (
    (navigator.userAgent.toLowerCase().indexOf('opera') !== -1 ||
      navigator.userAgent.toLowerCase().indexOf('opr') !== -1) &&
    !!(window as any).opr
  ) {
    return false;
  }
  // check if browser is not Chrome or Edge
  if (
    navigator.userAgent.toLowerCase().indexOf('edg') === -1 &&
    navigator.userAgent.toLowerCase().indexOf('chrome') === -1 &&
    // this is needed for chrome on iOS
    navigator.userAgent.toLowerCase().indexOf('crios') === -1
  ) {
    return false;
  }

  return true;
}
